var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1565_108543)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 19,
    stroke: "#012749",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24L20.1937 18.625C19.5707 17.8894 19.1695 16.992 19.0368 16.0372C18.9042 15.0824 19.0455 14.1096 19.4443 13.232C19.8432 12.3544 20.4831 11.6082 21.2897 11.0802C22.0962 10.5523 23.0361 10.2644 24 10.25C25.3361 10.2632 26.6125 10.8054 27.5497 11.7578C28.4868 12.7101 29.0083 13.9951 29 15.3313C29.0005 16.4968 28.6037 17.6278 27.875 18.5375L24 24ZM24 11.5C22.9949 11.5115 22.0355 11.9215 21.3324 12.6398C20.6293 13.3581 20.24 14.3261 20.25 15.3313C20.2542 16.2486 20.5842 17.1347 21.1812 17.8313L24 21.825L26.8937 17.75C27.4438 17.0634 27.7456 16.211 27.75 15.3313C27.76 14.3261 27.3707 13.3581 26.6676 12.6398C25.9645 11.9215 25.0051 11.5115 24 11.5Z",
    fill: "#012749"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.875C24.6904 15.875 25.25 15.3154 25.25 14.625C25.25 13.9346 24.6904 13.375 24 13.375C23.3096 13.375 22.75 13.9346 22.75 14.625C22.75 15.3154 23.3096 15.875 24 15.875Z",
    fill: "#012749"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16.5H30.25V17.75H31.5V26.5H16.5V17.75H17.75V16.5H16.5C16.1685 16.5 15.8505 16.6317 15.6161 16.8661C15.3817 17.1005 15.25 17.4185 15.25 17.75V26.5C15.25 26.8315 15.3817 27.1495 15.6161 27.3839C15.8505 27.6183 16.1685 27.75 16.5 27.75H31.5C31.8315 27.75 32.1495 27.6183 32.3839 27.3839C32.6183 27.1495 32.75 26.8315 32.75 26.5V17.75C32.75 17.4185 32.6183 17.1005 32.3839 16.8661C32.1495 16.6317 31.8315 16.5 31.5 16.5Z",
    fill: "#012749"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1565_108543",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_108543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_108543",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLegend);
export default __webpack_public_path__ + "static/media/locationLegend.83cd0fadd01eab083e4e1671dc0d4222.svg";
export { ForwardRef as ReactComponent };